export const ADDED_MENUS = 'ADDED_MENUS';

export const SELECTED_MENU = 'SELECTED_MENU';